import React from 'react';
import PropTypes from 'prop-types';
import { openQualtiveModal, isQualtiveEnabled } from './qualtive-loader';
import { useTranslator } from 'tradera-lang/translate';

export const QualtiveButton = ({ survey, icon, text, className }) => {
    const { t } = useTranslator();
    return isQualtiveEnabled() ? (
        <button
            className={className}
            onClick={() => openQualtiveModal(survey, t)}>
            {icon}
            {text}
        </button>
    ) : null;
};

QualtiveButton.propTypes = {
    survey: PropTypes.object.isRequired,
    text: PropTypes.string.isRequired,
    icon: PropTypes.node
};
